export default __webpack_public_path__ + "static/media/logo-mark-dark.066e06ae.svg";